import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="relative flex items-center justify-center h-screen bg-gray-50 overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center">
        <h1 className="text-[30rem] font-black text-everglade-100 select-none">
          404
        </h1>
      </div>
      <div className="relative z-10 text-center p-8">
        <h2 className="text-8xl font-extrabold text-[#4f9d4a] tracking-wider">404</h2>
        <p className="mt-2 text-2xl font-semibold text-gray-700">Page Not Found</p>
        <p className="mt-4 text-gray-500">
          Sorry, the page you are looking for could not be found.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block bg-everglade-600 text-white font-semibold px-8 py-3 rounded-md  hover:bg-everglade-400 transition-all duration-300 ease-in-out transform hover:scale-105"
        >
          Return to homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
